import { db, storage } from "./firebaseConfig";

// ADMIN FUNCTIONS
// ---------------------------------------------------------------------------------------------------
export async function GetCollection(collection, query = false, attribute = false, searchFor = false) {
    console.log('fetching')
    if (query === false) {
        return await db.collection(collection).get()
    }
    else {
        try {
            return await db.collection(collection).where(attribute, '==', searchFor).get()

        }
        catch (error) {

            return error.message

        }
    }
}

export async function GetDocument(collection, documentId) {
    return await db.collection(collection).doc(documentId).get()
}

export async function UpdateDocument(collection, document, imageBool) {
    if (imageBool) {
        await UploadImage(document.image, document.imagePath).then((url) => {
            document.image = url
            return db.collection(collection).doc(document.id).set(document)
        })
    }
    else {
        return db.collection(collection).doc(document.id).set(document)
    }
    return document
}

export async function UpdateAdminUser(user) {
    await UploadImage(user.image, user.imagePath).then((url) => {
        console.log(url)
        user.image = url
        return db.collection('users').doc(user.userId).set(user)
    })

    return user
}

export async function GetUser(id) {
    return await db.collection('users').doc(id).get()
}

export async function UploadBlogPost(post) {
    await UploadImage(post.image, post.imagePath).then((url) => {
        console.log(url)
        post.image = url
        return db.collection('blogPosts').doc(post.id).set(post)
    })

    return post
}

export async function GetPosts() {
    return await db.collection('blogPosts').get()
}

export async function GetPost(id) {
    return await db.collection('blogPosts').doc(id).get()
}

export async function GetRecipe(id) {
    return await db.collection('recipes').doc(id).get()
}

export async function GetAdmins() {
    return await db.collection('users').where('role', '==', 'admin').get()
}
export async function getMedia(type) {
    return await db.collection("media").where("type", '==', type).get()

}



export async function createUser(user) {
    await db.collection("users").doc(user.id).set(user)
    return user
}

export async function GetAllRecipes() {
    return await db.collection("recipes").get()
}

export async function GetForumTopics() {
    const topics = await db.collection('forumTopics').get()
    const topicsArray = topics.docs.map(doc => doc.data())

    for (const topic of topicsArray) {
        topic.threadCount = await GetTopicThreadCount(topic.title)
    }
    return topicsArray
}

export async function uploadTopic(topic) {
    await db.collection("forumTopics").doc(topic.id).set(topic)
    return topic
}

export async function uploadRecipe(recipe) {
    await db.collection("recipes").doc(recipe.id).set(recipe)
    return recipe
}

export async function uploadThread(thread) {
    await db.collection("forumThreads").doc(thread.id).set(thread)
    return thread
}

export async function GetForumThreads(id) {
    return await db.collection('forumThreads').where('topic', '==', id).get()
}

export async function GetTopicById(id) {
    return await db.collection('forumTopics').doc(id).get()
}

export async function GetThreadById(id) {
    return await db.collection('forumThreads').doc(id).get()
}

export async function GetTopicThreadCount(topic) {
    const threads = await db.collection('forumThreads').where('topic', '==', topic).get()
    const threadsArray = threads.docs.map(doc => doc.data())
    const threadCount = threadsArray.length
    return threadCount
}

export async function GetThreadMessages(thread) {
    return await db.collection('forumMessages').where('thread', '==', thread).get()
}

export async function GetAllOrdersByStatus(status) {
    return await db.collection("orders").where('status', '==', status).get()
}

export async function GetAllUsers() {
    return await db.collection("users").get()
}

export async function GetAllItems() {
    return await db.collection("items").get()
}

// CUSTOMER FUNCTIONS
// ---------------------------------------------------------------------------------------------------

export async function GetOrders(userId) {
    return await db.collection("orders").where("userId", "==", userId).get()
}

export async function GetOrder(id) {
    return await db.collection("orders").doc(id).get()

}



export async function CreateOrder(order) {
    await db.collection("orders").doc(order.number).set(order)
    return order

}


export async function deleteItem(order, item) {
    db.collection("items").doc(item.number).delete()

    storage.ref(`items/${item.imagePath}`).delete()



}


export async function UpdateOrder(order) {
    return await db.collection("orders").doc(order.number).update(order)
}

export function GenerateRandomNumber() {
    return Math.random().toFixed(6).split('.')[1]
}

export async function GetItems(order) {
    return await db.collection("items").where("order", "==", order.number).get()
}


export async function UploadImage(img, path) {
    const uploadTask = storage.ref(`${path}`).put(img)
    return uploadTask.then(uploadTaskSnapshot => {
        return uploadTaskSnapshot.ref.getDownloadURL()
    })
}

export async function CreateItem(item) {
    await UploadImage(item.imageUrl, item.imagePath).then((url) => {
        item.imageUrl = url
        return db.collection("items").doc(item.number).set(item)
    })
}


export async function UploadImages(item, images, path) {
    let urls = []

    await Promise.all(images.map(async (img, idx) => {
        await UploadImage(img, idx, path).then((url) => {
            urls[idx] = url
        })

    }))
    return urls
}



export async function UpdateItem(item) {
    return await db.collection("items").doc(item.number).update(item)

}

